// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TUnknownParam = any;

export const isDate: (d: TUnknownParam) => boolean = (d) => d instanceof Date;
export const isHTMLElement: (d: TUnknownParam) => boolean = (d) =>
  d instanceof Element || d instanceof Document;
export const isEmpty: (o: TUnknownParam) => boolean = (o) => Object.keys(o).length === 0;
export const isObject: (o: TUnknownParam) => boolean = (o) => o != null && typeof o === 'object';
export const hasOwnProperty: (o: TUnknownParam, ...args: TUnknownParam[]) => boolean = (
  o,
  ...args
) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  Object.prototype.hasOwnProperty.call(o, ...args);
export const isEmptyObject: (o: TUnknownParam) => boolean = (o) => isObject(o) && isEmpty(o);

type Callback<A> = (args: A) => void;
export const promisify =
  <T, A>(
    fn: (args: T, cb: Callback<A>, error: Callback<Error>) => void,
  ): ((args: T) => Promise<A>) =>
  (args: T) =>
    new Promise((resolve, reject) => {
      fn(
        args,
        (callbackArgs) => {
          resolve(callbackArgs);
        },
        (err: Error) => {
          reject(err);
        },
      );
    });
